import { useContext, useEffect, useState } from 'react';
import Card from 'components/card';
import Banner from './components/Banner';
import Content from './components/Content';
import { AuthContext } from 'contexts/AuthContext';
import commonServices from 'ApiService/Common/commonServices';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useRef } from 'react';
import Nodatafound from '../Nodatafound';

const Index = () => {
  const [salaryDetails, setSalaryDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [years, setYears] = useState([]);
  const [viewMode, setViewMode] = useState('monthly');
  const { state } = useContext(AuthContext);
  const pdRef = useRef();

  const fetchSalaryDetails = async () => {
    setLoading(true);
    try {
      const response = await commonServices.getOwnSalaryDetails({
        role: state?.user?.role,
        year: parseInt(year),
      });
      setSalaryDetails(response.data.data);
    } catch (error) {
      console.error('Error fetching salary details:', error);
      setSalaryDetails(null);
    } finally {
      setLoading(false);
    }
  };

  const handleYearChange = (e) => {
    setYear(e.target.value);
  };

  const handleMonthChange = (e) => {
    setMonth(parseInt(e.target.value));
  };

  const handleViewModeChange = (e) => {
    setViewMode(e.target.value);
  };

  const handleFetchClick = () => {
    fetchSalaryDetails();
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const availableYears = Array.from({ length: 5 }, (_, i) => currentYear - i);
    setYears(availableYears);
    fetchSalaryDetails(); // Initial fetch
  }, [year]);

  const downloadPDF = () => {
    const input = pdRef.current;
    if (!input) {
      console.error('PDF container reference (pdRef) not found.');
      return;
    }

    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;

      const scaleFactor = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const newWidth = imgWidth * scaleFactor;
      const newHeight = imgHeight * scaleFactor;
      const positionX = (pdfWidth - newWidth) / 2;
      const positionY = (pdfHeight - newHeight) / 2;

      pdf.addImage(imgData, 'PNG', positionX, positionY, newWidth, newHeight);
      pdf.save('salaryslip.pdf');
    });
  };

  return (
    <div className="mt-3 w-full rounded-[20px] font-dm md:h-[1150px] 3xl:px-52">
      <Card extra={'w-full xl:w-[95%] 3xl:w-[82%] mx-auto p-4 h-full'}>
        <div>
          <Banner
            salaryDetails={salaryDetails}
            handleYearChange={handleYearChange}
            handleMonthChange={handleMonthChange}
            handleViewModeChange={handleViewModeChange}
            handleFetchClick={handleFetchClick}
            years={years}
            year={year}
            month={month}
            viewMode={viewMode}
            downloadPDF={downloadPDF}
          />
          <div className="mx-auto -mt-[80px] overflow-visible px-2 md:-mt-10 md:px-14 lg:w-[90%] 3xl:w-[90%]">
            {loading ? (
              <div className="flex h-64 items-center justify-center">
                <div className="border-primary border-t-transparent h-8 w-8 animate-spin rounded-full border-4"></div>
              </div>
            ) : !salaryDetails ? (
              <div className="flex h-64 items-center justify-center text-lg text-gray-500">
                <Nodatafound title=" No data found , Contact Admin" />
              </div>
            ) : (
              <Content
                salaryDetails={salaryDetails}
                viewMode={viewMode}
                selectedMonth={month}
                pdRef={pdRef}
              />
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Index;
